<div>
    <p class="warning">Restoring PIN Overrides will terminate the effectivity of this PIN override group by setting the end date to
        today. It may not take effect until tomorrow.</p>
    <p class="warning">Please click the Confirm button if you wish to continue.</p>
    <button mat-raised-button matTooltip="Restore Default Pins" id="cancel-button" mat-dialog-close="true" class="buttons">
        Cancel
    </button>
    <button mat-raised-button matTooltip="Restore Default Pins" id="confirm-button" (click)="handleConfirm()" class="buttons">
        Confirm
    </button>
</div>
